import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children:ReactNode; resetKey?:string; fallback?:ReactNode };
type State = { failed:boolean };

export class SectionErrorBoundary extends Component<Props,State> {
  state:State={failed:false};
  static getDerivedStateFromError(){return{failed:true}}
  componentDidCatch(error:Error,info:ErrorInfo){console.error("Prive section render failed",error,info)}
  componentDidUpdate(previous:Props){if(this.state.failed&&previous.resetKey!==this.props.resetKey)this.setState({failed:false})}
  render(){return this.state.failed?(this.props.fallback||<div className="error-box">这一部分暂时无法显示，请刷新后重试。</div>):this.props.children}
}

export class AppErrorBoundary extends Component<{children:ReactNode},State> {
  state:State={failed:false};
  static getDerivedStateFromError(){return{failed:true}}
  componentDidCatch(error:Error,info:ErrorInfo){console.error("Prive app render failed",error,info)}
  render(){
    if(!this.state.failed)return this.props.children;
    return <div className="fatal-error"><div><span className="fatal-mascot" aria-hidden="true"/><h1>页面刚刚走神了</h1><p>你的数据仍然安全保存着。重新载入即可继续使用。</p><button className="button" onClick={()=>window.location.reload()}>重新载入工作台</button></div></div>;
  }
}
